import { DataBean } from "../../DataBean";


export class HealthAttentionService extends DataBean {


    public async getHealthAttentionServiceCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAttentionServiceCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}